<template>
  <el-menu
    ref="elMenuRef"
    class="menu-type"
    :unique-opened="true"
   
  >
    <el-submenu
      :index="`${index}`"
      :key="item.id"
      v-for="(item, index) in headerData"
    >
      <template slot="title">
        <div @click="subHandleClick(item)">
          <span>{{ item.name }}</span>
        </div>
      </template>
      <el-menu-item
        :index="`${index}-${index2}`"
        :key="item2.id"
        v-for="(item2, index2) in item.list"
        style="color: #54667a"
        @click="handleClick(item2, index2)"
      >
        <span class="icon"></span>
        <span class="text">{{ item2 }}</span></el-menu-item
      >
    </el-submenu>
  </el-menu>
</template>

<script>

export default {
  data() {
    return {
      value: "",
      headerData: [
        {
          name: "Blockchan Data",
          id: 0,
          list: [
            "User Transactions",
            "Peak TPS",
            "Transaction signature total",
            "Average Gas Unit Price",
            "Daily Gas Used",
          ],
          show: true,
        },
        {
          name: "TTOS circulation",
          id: 1,
          list: [
            "User Bonus & Burned",
            "TTOS Transaction Volume",
            "TTOS Supply & Staking",
          ],
          show: false,
        },
        {
          name: "Accounts",
          id: 2,
          list: ["Total Account & Active Account", "New Accounts Created"],
          show: false,
        },
        {
          name: "Contracts",
          id: 3,
          list: [
            "Daily contract call",
            "Daily Contract Call Distribution",
            "Contract Count",
          ],
          show: false,
        },
      ],
      ind: 0,
    };
  },
  mounted() {},
  methods: {
    handleClick(data, index) {
      console.log(data);
      console.log(index);

      this.$emit("menuHandleClick", data);
    },
    subHandleClick(data) {
      this.ind = data.id;
      this.$emit("menuHandleClick", data);
      //取消当前导航选中项
      this.$refs.elMenuRef.activeIndex = null;
    },
  },
};
</script>
<style lang="less">
.el-submenu{
  padding-right: 10px !important;
//  padding-left: 12px !important;
}
.el-submenu__title {
  color: #ffffff !important;
  background: #000000;

  border-radius: 16px 16px 16px 16px;
  opacity: 1;
  border: 3px solid #323f3b;
}
.el-submenu .el-menu {
  margin-top: 20px !important;
}
.el-menu-item {
  color: #ffffff !important;
}
.el-menu {
  // background: none !important;
  background: #000000;
  border-radius: 16px 16px 16px 16px;
  opacity: 1;
  border: 3px solid;
  border: none;
  overflow: hidden;
  opacity: 1 !important;
}
.el-submenu__title i {
  color: #ffffff;
}
.el-submenu.is-opened .el-submenu__title {
  //设置一级菜单点开后的状态
  color: #00e79a !important;
  // background-color: #252f3b !important;
  // border-left: 2px solid #409eff;
}

.el-menu-item:focus,
.el-menu-item:hover,
.el-menu-item:hover i,
.el-menu .el-submenu .el-submenu__title:hover,
.el-menu .el-submenu .el-submenu__title:hover i,
.el-menu .el-submenu .el-submenu__title:focus {
  background: none;
  color: #00e79a !important;
}
.el-menu-item.is-active {
  //background: #24283c;
  color: #00e79a !important;
}
.el-menu-item.is-active::before {
  content: "";
  // position: absolute;
  // border-left: 2px solid #f4bf08;
  // height: 34px;
  // top: 5px;
  // left: 0px;
  color: #00e79a !important;
}
.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  color: #00e79a !important;
}
</style>
